export class DataCell {
    value: any;
    type?: string;
    format?: string;
}
